import React, { Component } from 'react';
import PropTypes from 'prop-types';
import InternetBankingActions from '../../actions/InternetBankingActions';
import { LoadingSpinner } from '../LoadingSpinner';

class BottomNavigationBox extends Component {
  constructor(props) {
    super(props);

    this.onClickBack = this.onClickBack.bind(this);
    this.onClickNext = this.onClickNext.bind(this);
  }
  /**
   * Triggered when user clicks back button.
   * If we were given a back task ID, go there.
   *
   * @param  {Event} e  Click event.
   */
  onClickBack(e) {
    if (this.props.backTaskId) {
      e.preventDefault();
      InternetBankingActions.navigateToWebTask(this.props.backTaskId);
    }
  }

  /**
   * Triggered when user clicks 'next' button.
   * If we were given a click handler, call it. Otherwise, navigate to task.
   *
   * @param  {Event} e  Click event.
   */
  onClickNext(e) {
    e.preventDefault();

    if (this.props.disabled || this.props.isLoading) {
      e.stopPropagation();
    }

    if (this.props.onClickNext) {
      this.props.onClickNext(e);
      return;
    }

    InternetBankingActions.navigateToWebTask(this.props.nextTaskId);
  }

  render() {
    return (
      <div className="bottom-navigation-box">
        {this.props.hasSeparator === true ? <hr /> : null}
        <div className="row">
          <div
            className={`col-xs-12 text-center${
              this.props.backTaskId ? ' col-md-6 col-md-push-5' : ''
            }${this.props.className ? ' ' + this.props.className : ''}`}
          >
            <button
              onClick={this.onClickNext}
              className={`btn btn-primary btn-lg btn-next${
                this.props.disabled || this.props.isLoading
                  ? ' btn-disabled '
                  : ''
              }`}
              name={this.props.dataAnchorNext}
              data-anchor={this.props.dataAnchorNext}
              disabled={this.props.disabled || this.props.isLoading}
            >
              <span>{this.props.nextButtonLabel}</span>
              {this.props.isLoading && <LoadingSpinner />}
            </button>
          </div>
          {this.props.backTaskId && (
            <div className="col-xs-12 col-md-6 col-md-pull-5 text-center">
              <button
                onClick={this.onClickBack}
                name={this.props.dataAnchorBack}
                className="btn btn-primary btn-lg btn-back"
                data-anchor={this.props.dataAnchorBack}
              >
                Go Back
              </button>
            </div>
          )}
        </div>
      </div>
    );
  }
}

BottomNavigationBox.defaultProps = {
  disabled: false,
  nextButtonLabel: 'Next',
};

BottomNavigationBox.propTypes = {
  disabled: PropTypes.bool,
  nextButtonLabel: PropTypes.string,
  backTaskId: PropTypes.string,
  nextTaskId: PropTypes.string,
  onClickNext: PropTypes.func,
  dataAnchorNext: PropTypes.string,
  dataAnchorBack: PropTypes.string,
  isLoading: PropTypes.bool,
  className: PropTypes.string,
  hasSeparator: PropTypes.bool,
};

export { BottomNavigationBox };
